<template>
  <div>
    <!-- 右键 -->
    <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
    <!-- 搜索 -->
    <div style="padding-bottom: 3px;">
      <!--<Input size="small" v-model="searchMsg" placeholder="搜索" style="width: 180px;"/>-->
      <!--      <Select-->
      <!--        v-model="searchMsg"-->
      <!--        size="small"-->
      <!--        filterable-->
      <!--        remote-->
      <!--        :remote-method="getSearchOption"-->
      <!--        style="width: 180px;"-->
      <!--        clearable-->
      <!--      >-->
      <!--        <Option v-for="(option, index) in SearchResultData" :value="option" :key="index">{{option}}</Option>-->
      <!--      </Select>-->
      <Input size="small" clearable v-model="searchMsg" placeholder="车牌/主机名称/分组名称"
             style="width: 150px; margin-right: 3px;"></Input>

      <DatePicker type="daterange" size="small" placeholder="请选择时间" style="width: 180px;"
                  v-model="dateFilter"></DatePicker>
      <Button type="primary" size="small" style="margin-left:3px;" :disabled="listLoadding" @click="onFind">查询</Button>
      <Button size="small" type="primary" style="margin-left: 5px;" @click="onExportExcelClick">导出</Button>
    </div>
    <!-- 报表主页面 -->
    <div style="width: 100%;">
      <Table
        border
        size="small"
        :columns="columns"
        :data="data"
        highlight-row
        ref="table"
        @on-sort-change="onSortChange"
        @on-filter-change="filterChange"
        @contextmenu.prevent.native="onTableRightClick($event)"
        :height="tableHeight">
      </Table>
    </div>
    <!-- 蒙版 -->
    <div class="mb" v-if="listLoadding"></div>
    <!-- 分页控件 -->
    <Page :total="totalElements"
          :page-size="pagesize"
          :show-total="true"
          :current="pageIndex"
          @on-change="setPage"
          show-elevator
          show-sizer @on-page-size-change="refreshPage" :page-size-opts="pagesizeopts"
          style="text-align:right;margin-top:10px"/>
    <!-- 自定义显示列 -->
    <web-table-columns-modal
      :columnList.sync="columns"
      :tableName="$options.name"
      v-model="webTableColumnsModal">
    </web-table-columns-modal>
    <stop-sim-card-add-remark-modal  v-model="StopSimCardAddRemarkModal" :initValue="StopSimCardAddRemarkModalId"
                                     @on-success="refreshPage"></stop-sim-card-add-remark-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import store from '../../store'
import { GPS } from '@/libs/positonUtils'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import StopSimCardAddRemarkModal from '@/view/da/components/stop-sim-card-add-remark-modal'
import { genURLParams } from '@/libs/urlparamhelper'

export default {
  name: 'stopsimcardanalysiss',
  components: {
    StopSimCardAddRemarkModal
  },
  data () {
    return {
      // 追加备注
      StopSimCardAddRemarkModal: false,
      StopSimCardAddRemarkModalId: null,

      operationFilter: null,

      dateFilter: [],
      startDate: null,
      endDate: null,

      columns: [
        {
          title: 'id',
          key: 'id',
          width: 65,
          resizable: true,
          sortable: 'custom',
          align: 'center'
        },
        {
          title: '主机号',
          key: 'terminalNum',
          width: 120,
          resizable: true,
          align: 'center'
        },
        {
          title: '停用SIM卡',
          key: 'simInfo',
          width: 140,
          resizable: true,
          align: 'center',
          render: function (h, params) {
            if (params.row.simInfo) {
              let simNum = params.row.simInfo.simNum
              return h('div', simNum)
            }
          }
        }, {
          title: '使用中SIM卡',
          key: 'newSimInfo',
          width: 140,
          resizable: true,
          align: 'center',
          render: function (h, params) {
            if (params.row.newSimInfo) {
              let simNum = params.row.newSimInfo.simNum
              return h('div', simNum)
            }
          }
        },
        {
          title: '车辆信息',
          resizable: true,
          tooltip: 'true',
          ellipsis: 'true',
          width: 190,
          render: (h, params) => {
            let registrationNum = ''
            let identificationCode = ''
            let vin = ''
            if (params.row.vehicleInfo) {
              registrationNum = params.row.vehicleInfo.registrationNum === null ? '无' : params.row.vehicleInfo.registrationNum
              identificationCode = params.row.vehicleInfo.identificationCode === null ? '无' : params.row.vehicleInfo.identificationCode
              vin = params.row.vehicleInfo.vin === null ? '无' : params.row.vehicleInfo.vin
            } else if (params.row.simInfo) {
              if (params.row.simInfo.positioningDeviceInfo) {
                if (params.row.simInfo.positioningDeviceInfo.vehicleInfo) {
                  registrationNum = params.row.simInfo.positioningDeviceInfo.vehicleInfo.registrationNum === null ? '无' : params.row.simInfo.positioningDeviceInfo.vehicleInfo.registrationNum
                  identificationCode = params.row.simInfo.positioningDeviceInfo.vehicleInfo.identificationCode === null ? '无' : params.row.simInfo.positioningDeviceInfo.vehicleInfo.identificationCode
                  vin = params.row.simInfo.positioningDeviceInfo.vehicleInfo.vin === null ? '无' : params.row.simInfo.positioningDeviceInfo.vehicleInfo.vin
                } else {
                  registrationNum = '无'
                  identificationCode = '无'
                  vin = '无'
                }
              } else {
                registrationNum = '无'
                identificationCode = '无'
                vin = '无'
              }
            } else {
              registrationNum = '无'
              identificationCode = '无'
              vin = '无'
            }
            return h('div', [
              h('div', '车牌:' + registrationNum + '(识别码:' + identificationCode + ')'),
              h('div', '车架号:' + vin)
            ])
          }
        },
        {
          title: 'SIM卡状态',
          key: 'simNumState',
          width: 200,
          resizable: true,
          align: 'center',
          render: function (h, params) {
            if (params.row.simNumState == 0) {
              return h('div', [
                h('Tag', {
                  props: {
                    size: 'small',
                    type: 'dot',
                    color: 'success'
                  }
                }, '使用')
              ])
            } else if (params.row.simNumState == 1) {
              return h('div', [
                h('Tag', {
                  props: {
                    size: 'small',
                    type: 'dot',
                    color: 'blue'
                  }
                }, '停止服务')
              ])
            } else if (params.row.simNumState == 2) {
              return h('div', [
                h('Tag', {
                  props: {
                    size: 'small',
                    type: 'dot',
                    color: 'warning'
                  }
                }, '重新开通中')
              ])
            }
          }
        },
        {
          title: '运营商',
          resizable: true,
          key: 'simInfo',
          ellipsis: 'true',
          width: 150,
          filters: [
            { label: '中国移动', value: 1 },
            { label: '中国联通', value: 2 },
            { label: '中国电信', value: 3 },
            { label: '珠海移动专网', value: 4 },
            { label: '中国移动-东莞中智', value: 5 },
            { label: '中国移动-佛山交协', value: 6 },
            { label: '中国电信-中山邦悦', value: 7 },
            { label: '中国移动-河北九宸', value: 8 },
            { label: '中国移动-中山邦悦', value: 9 },
            { label: '中国联通-中山邦悦', value: 10 },
            { label: '中国移动-深圳晓聪', value: 11 }
          ],
          filterMultiple: false,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.operationFilter = genQueryParam('simInfo.operation', 'EQ', val[0])
            } else {
              this.operationFilter = null
            }
          },
          render: function (h, params) {
            let operation = params.row.simInfo.operation
            if (operation === 1) {
              return h('div', '中国移动')
            } else if (operation === 2) {
              return h('div', '中国联通')
            } else if (operation === 3) {
              return h('div', '中国电信')
            } else if (operation === 4) {
              return h('div', '珠海移动专网')
            } else if (operation === 5) {
              return h('div', '中国移动-东莞中智')
            } else if (operation === 6) {
              return h('div', '中国移动-佛山交协')
            } else if (operation === 7) {
              return h('div', '中国电信-中山邦悦')
            } else if (operation === 8) {
              return h('div', '中国移动-河北九宸')
            } else if (operation === 9) {
              return h('div', '中国移动-中山邦悦')
            } else if (operation === 10) {
              return h('div', '中国联通-中山邦悦')
            } else if (operation === 11) {
              return h('div', '中国移动-深圳晓聪')
            }
          }
        },
        {
          title: '创建时间',
          key: 'createDatetime',
          width: 180,
          resizable: true,
          sortable: 'custom',
          align: 'center',
          render: function (h, params) {
            if (params.row.createDatetime) {
              let d = new Date(params.row.createDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '停卡时间',
          key: 'stopDatetime',
          width: 180,
          resizable: true,
          sortable: 'custom',
          align: 'center',
          render: function (h, params) {
            if (params.row.stopDatetime) {
              let d = new Date(params.row.stopDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '更新时间',
          key: 'updateDatetime',
          width: 180,
          resizable: true,
          sortable: 'custom',
          align: 'center',
          render: function (h, params) {
            if (params.row.updateDatetime) {
              let d = new Date(params.row.updateDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '备注',
          key: 'remark',
          width: 200,
          resizable: true,
          ellipsis: 'true',
          tooltip: 'true',
          align: 'center'
        },
        {
          title: '操作',
          resizable: true,
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          width: 250,
          fixed: 'right',
          render: (h, params) => {
            let display = []

            display.push(
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.StopSimCardAddRemarkModalId = params.row.id
                    this.StopSimCardAddRemarkModal = true
                  }
                }
              }, '追加备注')
            )
            if (params.row.simNumState == 0 || params.row.simNumState == 2) {
              display.push(
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: '确认停止服务',
                        content: '<p>注意：停止服务后将无数据上传</p>',
                        onOk: () => {
                          store.dispatch('StopSimCardDataAnalysisResultServ_ConfirmStopSim', {
                            params: {
                              id: params.row.id
                            },
                            urlparams: null
                          }).then(() => {
                            this.refreshPage(this.pageFilter)
                            this.$Message.success('停卡成功')
                          }).catch(err => {
                            this.$Message.error(err)
                          })
                        },
                        onCancel: () => {
                        }
                      })
                    }
                  }
                }, '停止服务')
              )
            }
            // if (params.row.simNumState == 2) {
            display.push(
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '确认重新开通',
                      content: '<p>注意：重新开通后将恢复数据上传</p>',
                      onOk: () => {
                        store.dispatch('StopSimCardDataAnalysisResultServ_ReopeningSim', {
                          params: {
                            id: params.row.id
                          },
                          urlparams: null
                        }).then(() => {
                          this.refreshPage(this.pageFilter)
                          this.$Message.success('重新开通成功')
                        }).catch(err => {
                          this.$Message.error(err)
                        })
                      },
                      onCancel: () => {
                      }
                    })
                  }
                }
              }, '开通服务')
            )
            // }
            return h('div', display)
          }
        }
      ],

      data: [],
      tableHeight: 160,
      totalElements: null,
      pagesize: 12,
      pageFilter: 30,
      pagesizeopts: [30, 50, 100, 200],
      sort: null,
      pageIndex: 1,
      listLoadding: false,
      webTableColumnsModal: false,
      menuList: [
        { title: '设置表格列', content: {} }
      ],
      // 搜索关键词
      searchMsg: ''
    }
  },
  methods: {
    /**
     * 表格右键回调
     */
    onTableRightClick (e) {
      this.$refs.contextMenuRef.showMenu(e, this.$el, 20, 20)
    },
    /**
     * 右键菜单点击回调
     */
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.webTableColumnsModal = true
      }
    },
    // 获取数据
    getData (pageIndex) {
      console.log('setPage' + pageIndex)
      this.pageIndex = pageIndex
      this.listLoadding = true

      let sortParam = null
      let queryParams = []
      let qo2 = null

      if (this.sort) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      } else {
        sortParam = genSortParam('id', false)
      }
      if (this.startDate && this.endDate) {
        queryParams.push(genQueryParam('updateDatetime', 'BTDT', this.startDate, this.endDate))
      }

      if (this.operationFilter) {
        qo2 = this.operationFilter
      }

      this.listLoadding = true
      store.dispatch('StopSimCardDataAnalysisResultServ_GetPage', {
        params: null,
        urlparams: {
          q: queryParams,
          qo2: qo2,
          keyword: this.searchMsg,
          ps: this.pageFilter,
          p: pageIndex,
          sort: sortParam
        }
      }).then(res => {
        console.log(res)
        this.listLoadding = false
        this.data = res.data.content
        this.totalElements = res.data.totalElements
        this.pagesize = res.data.pageable.pageSize
      }).catch(err => {
        console.log(err)
        this.listLoadding = false
      })
    },
    // 搜索
    onFind () {
      if (this.dateFilter.length == 0) {
        this.startDate = null
        this.endDate = null
        this.setPage(1)
        return
      } if (this.dateFilter[0] === '' || this.dateFilter[1] === '') {
        this.startDate = null
        this.endDate = null
        this.setPage(1)
        return
      }
      let startDate = this.dateFilter[0]
      let endDate = this.dateFilter[1]
      this.startDate = new Date(startDate).Format('yyyy-MM-dd 00:00:00')
      this.endDate = new Date(endDate).Format('yyyy-MM-dd 23:59:59')
      this.getData(1)
    },
    onExportExcelClick () {
      let queryParams = []
      if (this.dateFilter[0] && this.dateFilter[1]) {
        let startDatetime = new Date(this.dateFilter[0]).Format('yyyy-MM-dd 00:00:00')
        let endDatetime = new Date(this.dateFilter[1]).Format('yyyy-MM-dd 23:59:59')
        queryParams.push(genQueryParam('updateDatetime', 'BTDT', startDatetime, endDatetime))
      }
      let urlparams = {
        q: queryParams,
        keyword: this.keywordFilter
      }
      let url = '/api/da/stopsimcarddata/getexcelreport' + genURLParams(urlparams)
      window.location.href = url
    },
    filterChange () {
      this.refreshPage()
    },
    // 分页
    setPage (pageIndex) {
      this.getData(pageIndex)
    },
    onSortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage(this.pageFilter)
    },
    // 刷新当前页
    refreshPage (value) {
      this.pageFilter = value
      this.setPage(this.pageIndex)
    }
  },
  mounted () {
    this.$nextTick(() => {
      // 窗口的大小自适应
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 100
      window.onresize = () => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 100
      }
    })

    // 初始化数据
    this.getData(1)
  }
}
</script>

<style scoped>

</style>
